/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { useEffect } from 'react';

import { REGISTRATION_KIND_OVERLAY } from './ambient-context/constants';
import { useCommandIntelligence } from './CommandIntelligenceContext';

/**
 * Registers Command Intelligence configuration for the current subtree.
 * Mount a single registrar near the app root inside ConnexDesignSystem children.
 */
export const useRegisterCommandIntelligence = ({
  commandIntelligenceConfig,
  renderContextBar,
  getItemKey,
  maxAttachedItems,
  prefsScopeId,
  widthCacheKey,
  enabled = true,
}) => {
  const { configure, clearConfiguration } = useCommandIntelligence();

  useEffect(() => {
    if (!commandIntelligenceConfig) {
      return undefined;
    }

    configure({
      registrationKind: REGISTRATION_KIND_OVERLAY,
      commandIntelligenceConfig,
      renderContextBar,
      getItemKey,
      maxAttachedItems,
      prefsScopeId,
      widthCacheKey,
      enabled,
    });

    return () => {
      clearConfiguration({ registrationKind: REGISTRATION_KIND_OVERLAY });
    };
  }, [
    configure,
    clearConfiguration,
    commandIntelligenceConfig,
    renderContextBar,
    getItemKey,
    maxAttachedItems,
    prefsScopeId,
    widthCacheKey,
    enabled,
  ]);
};
